'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, event_id, adj_id) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({
      feis_id: feis_id,
      event_id: event_id,
      adj_id: adj_id

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisPrefixUrl)(feis_id) + '/events/' + event_id + '/adjudicators/' + adj_id + '/scores'
      },
      types: ['GET_SCORESHEET_START', 'GET_SCORESHEET', 'GET_SCORESHEET_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/scores/getScoresheet.js
// module id = 108
// module chunks = 0